export default __webpack_public_path__ + "static/media/r77-app.2c4293ba.svg";